module.exports = MaterialUI.SnackbarContent;